const ADMIN_PANEL = 'admin'
const HTA_BMW = 'hta bmw'
const HTA_MB = 'hta mb'
const HTA_JLR = 'hta jlr'
const HTA_VW = 'hta vw'
const HTA_BYD = 'hta byd'
const HTA_VW_SG = 'hta vw sg'

const adminPermissionDict = [
  { label: 'Admin Panel', value: ADMIN_PANEL },
  { label: 'Tyre Database (BMW)', value: HTA_BMW },
  { label: 'Tyre Database (Mercedes)', value: HTA_MB },
  { label: 'Tyre Database (JLR)', value: HTA_JLR },
  { label: 'Tyre Database (Volkswagen Malaysia)', value: HTA_VW },
  { label: 'Tyre Database (BYD)', value: HTA_BYD },
  { label: 'Tyre Database (Volkswagen Singapore)', value: HTA_VW_SG },
]
module.exports = {
  ADMIN_PANEL,
  HTA_BMW,
  HTA_MB,
  HTA_JLR,
  HTA_VW,
  HTA_BYD,
  HTA_VW_SG,
  adminPermissionDict,
}
